<template>
  <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.5,12.976a1,1,0,0,0-.426-.82A10.367,10.367,0,0,0,8,10.5a10.367,10.367,0,0,0-6.074,1.656,1,1,0,0,0-.426.82V15.5h13Z"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="8" cy="4" fill="none" r="3.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
